import {
  Agreement,
  Commitment,
  Compensation,
  IAgreement,
  ICommitment,
  ICompensation,
  IOpportunityAttachments,
  IOpportunityDetail,
  IOrganization,
  IPlace,
  ISaveOpportunityLanguage,
  IStartDate,
  IStrengthExperienceSelection,
  ITimeframe,
  Member,
  OpportunityAttachments,
  OpportunityDetail,
  Organization,
  Place,
  SaveOpportunityDeadline,
  SaveOpportunityLanguage,
  StartDate,
  StrengthExperienceSelection,
  Timeframe
} from "@/services/DTOs";
import { IPrefilledStatus, PrefilledStatus } from "@/services/DTOs/PrefilledStatus";

export interface ISaveOpportunityDraft {
  opportunity: string;
  objective: string;
  strengths: IStrengthExperienceSelection[];
  organizations: IOrganization[];
  languages: ISaveOpportunityLanguage[];
  commitment: ICommitment | undefined;
  timeframe: ITimeframe | undefined;
  timezones: string[] | undefined;
  startDate: IStartDate | undefined;
  place: IPlace;
  sponsorVisa?: string;
  compensation: ICompensation | undefined;
  agreement: IAgreement | undefined;
  details: IOpportunityDetail[];
  attachments: IOpportunityAttachments[];
  deadline: SaveOpportunityDeadline | string;
  members: Member[];
  prefilledStatus?: IPrefilledStatus;
  locale: string;
}

export class SaveOpportunityDraft {
  public opportunity: string;
  public objective: string;
  public strengths: StrengthExperienceSelection[];
  public organizations: Organization[];
  public languages: SaveOpportunityLanguage[];
  public commitment: Commitment | undefined;
  public timeframe: Timeframe | undefined;
  public timezones: string[] | undefined;
  public startDate: StartDate | undefined;
  public place: Place;
  public sponsorVisa?: string;
  public compensation: Compensation| undefined;
  public agreement: Agreement | undefined;
  public details: OpportunityDetail[];
  public attachments: OpportunityAttachments[];
  public deadline: SaveOpportunityDeadline | string;
  public members: Member[];
  public prefilledStatus?: PrefilledStatus;
  public locale: string;

  constructor(data: ISaveOpportunityDraft) {
    this.opportunity = data.opportunity;
    this.objective = data.objective;
    this.strengths = data.strengths;
    this.organizations = data.organizations.map((o) => new Organization(o));
    this.languages = data.languages;
    this.commitment = data.commitment;
    this.timeframe = data.timeframe;
    this.timezones = data.timezones;
    this.startDate = data.startDate;
    this.place = data.place;
    this.sponsorVisa = data.sponsorVisa;
    this.compensation = data.compensation ? new Compensation(data.compensation) : undefined;
    this.agreement = data.agreement;
    this.details = data.details;
    this.attachments = data.attachments;
    this.deadline = data.deadline;
    this.members = data.members;
    this.prefilledStatus = data.prefilledStatus ? new PrefilledStatus(data.prefilledStatus) : undefined;
    this.locale = data.locale;
  }
}
